import ErrorScreen from '@components/v2/layout/ErrorScreen/ErrorScreen';
import NotFoundIllustration from '@components/v2/layout/ErrorScreen/svg/NotFoundIllustration';
import LangEnum from '../../../../lang/LangEnum';
import useNotFoundPage from './hooks/useNotFoundPage';

interface NotFoundPageProps {
  title?: LangEnum;
  description?: LangEnum;
  hasHomeAction?: boolean;
}

const NotFoundPage = ({
  title = LangEnum.GLOBAL_PAGE_NOT_FOUND_TITLE,
  description = LangEnum.GLOBAL_PAGE_NOT_FOUND_DESCRIPTION,
  hasHomeAction = true,
}: NotFoundPageProps) => {
  const { goToHome } = useNotFoundPage();

  return (
    <ErrorScreen
      title={{ text: title }}
      description={{ text: description }}
      illustration={<NotFoundIllustration />}
      actions={
        hasHomeAction
          ? { primary: { label: LangEnum.GLOBAL_GO_TO_HOME_PAGE, onClick: goToHome } }
          : undefined
      }
    />
  );
};

export default NotFoundPage;
